import { useCallback, useEffect, useRef, useState } from 'react';

export interface AsyncState<T> { data: T | null; loading: boolean; error: Error | null; reload: () => void }

/** Minimal fetch-in-hook with abort + reload. Swap for react-query later without touching components. */
export function useAsync<T>(fn: (signal: AbortSignal) => Promise<T> | null, deps: unknown[]): AsyncState<T> {
  const [st, set] = useState<Omit<AsyncState<T>, 'reload'>>({ data: null, loading: true, error: null });
  const [tick, setTick] = useState(0); const fnRef = useRef(fn); fnRef.current = fn;
  useEffect(() => {
    const ac = new AbortController(); const p = fnRef.current(ac.signal);
    if (!p) { set({ data: null, loading: false, error: null }); return; }
    set(s => ({ ...s, loading: true, error: null }));
    p.then(data => !ac.signal.aborted && set({ data, loading: false, error: null })).catch(error => !ac.signal.aborted && set({ data: null, loading: false, error }));
    return () => ac.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, tick]);
  return { ...st, reload: useCallback(() => setTick(t => t + 1), []) };
}
